import {backAdmin} from "@/lib/api/axios";

export const catNipApi = [
   {url: `${backAdmin}/catnip`, name: 'catnip.get', method: 'GET'},
   {url: `${backAdmin}/catnip`, name: 'catnip.update', method: 'PUT'},

   {url: `${backAdmin}/catnip/news`, name: 'catnip.news.list', method: 'GET'},
   {url: `${backAdmin}/catnip/news`, name: 'catnip.news.create', method: 'POST'},
   {url: `${backAdmin}/catnip/news/{id}`, name: 'catnip.news.update', method: 'POST'},
   {url: `${backAdmin}/catnip/news/{id}`, name: 'catnip.news.delete', method: 'DELETE'},
]